import { LNGS_NAMESPACE_SEGMENT } from '@ingenico/util-i18n-config';
import { CoreButton } from '@ingenico/react-ui/core-button';
import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import { BackgroundColor, BackgroundShape, SideMenuIcon } from '@ingenico/react-ui/side-menu-icon';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { toString } from 'lodash-es';
import type { ReactNode } from 'react';
import type { DashboardRowContentProps } from './DashboardRowContent.model';
import styles from './DashboardRowContent.module.scss';
import { useDashboardRowContent } from './useDashboardRowContent.hook';

export function DashboardRowContent({ dashboardRowData }: DashboardRowContentProps): ReactNode {
  const { t, isError, openNewTab, isDisabled, getTitle, getCount, shouldShowViewButton, iconName } =
    useDashboardRowContent({
      dashboardRowData,
    });

  return (
    <div className={styles.dashboardRowContent__container}>
      <SideMenuIcon
        backgroundColor={BackgroundColor.ShadesInfo050}
        backgroundShape={BackgroundShape.Rounded}
        customClassName={styles.dashboardRowContent__sideMenuIconCustom}
        name={iconName}
        size="medium"
      />
      <div className={styles.dashboardRowContent__rightContent}>
        <CoreTypography variant={CoreTypographyVariant.Title03Medium}>{getTitle}</CoreTypography>
        {!isError && <CoreTypography variant={CoreTypographyVariant.Display02SemiBold}>{getCount}</CoreTypography>}
        {dashboardRowData.shortDescription && !isError && (
          <CoreTypography variant={CoreTypographyVariant.Body02Regular}>
            {toString(
              t(`dashboardSection.shortDescription.${dashboardRowData.entity}`, {
                ns: LNGS_NAMESPACE_SEGMENT.MERCHANT,
              }),
            )}
            {dashboardRowData.shortDescription}
          </CoreTypography>
        )}
        {isError && (
          <CoreTypography
            customClassName={styles.dashboardRowContent__errorText}
            variant={CoreTypographyVariant.Body02Regular}
          >
            {t('dashboardSection.error.default', { ns: LNGS_NAMESPACE_SEGMENT.MERCHANT })}
          </CoreTypography>
        )}
        {shouldShowViewButton && (
          <CoreButton
            className={styles.dashboardRowContent__coreButton}
            coreTypographyVariant={CoreTypographyVariant.Body02Medium}
            disabled={isDisabled}
            endIcon={<OpenInNewIcon />}
            onClick={openNewTab}
            variant="text"
          >
            {t('button.view', { ns: LNGS_NAMESPACE_SEGMENT.MERCHANT })}
          </CoreButton>
        )}
      </div>
    </div>
  );
}
